"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExploDashboardType = void 0;
var ExploDashboardType;
(function (ExploDashboardType) {
    ExploDashboardType["PERFORMANCE"] = "PERFORMANCE";
    ExploDashboardType["STOREFRONT_EXPLORER"] = "STOREFRONT_EXPLORER";
})(ExploDashboardType || (exports.ExploDashboardType = ExploDashboardType = {}));
